/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class AppointmentRequest extends MainRequest{

    static addAppointment(data, token) {
        return this.postSEC(ServicePath.APPOINTMENT_ADD, data, token);
    }

    static listAllAppointments(token) {
        return this.getSEC(ServicePath.APPOINTMENT_LIST_ALL);
    }

    static updateAppointment(data, token) {
        return this.postSEC(ServicePath.APPOINTMENT_UPDATE, data);
    }

    static deleteAppointment(data, token) {
        return this.postSEC(ServicePath.APPOINTMENT_DELETE, data);
    }

    static listAppointmentById(data, token) {
        return this.postSEC(ServicePath.APPOINTMENT_LIST_BY_ID, data);
    }    
    
    static listAppointmentByConsultingRoom(data, token) {
        return this.postSEC(ServicePath.APPOINTMENT_LIST_BY_CONSULTING_ROOM, data);
    }

    static notificationAppointment(data){
        return this.postSEC(ServicePath.APPOINTMENT_NOTIFICATION,data);
    }

    static listAppointmentByBranchOfficeDate(data) {
        return this.postSEC(ServicePath.APPOINTMENT_ALL_BY_BRANCH_AND_RANGE, data);
    }

    static listPending(data){
        return this.postSEC(ServicePath.APPOINTMENT_ALL_PENDING, data);
    }

    static updateStatus(data){
        return this.postSEC(ServicePath.APPOINTMENT_UPDATE_STATUS, data);
    }

    static listAppointmentBySpeciality(data){
        return this.postSEC(ServicePath.APPOINTMENT_LIST_ALL_BY_SPECIALITY, data)
    }

     /**
     * @author Fernando FH
     * @created 06/09/2022
     *@description Cancelar una lista de citas, desde el módulo de somatometría.
     * */
    static cancelAppointmentSomatometry(data){
        return this.postSEC(ServicePath.APPOINTMENT_CANCEL_FROM_SOMATOMETRY, data);
    }

}
